import * as React from 'react';
import dayjs from 'dayjs';
import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { useState, useEffect } from 'react';
import moment from 'moment';



// BF - 2025 -> setHighlightedDays is state that is an array of numbers [1,2,4](DD day). this state highlights the days that have a fight in it, prime to be taken out.
// BF - 2025 -> Need this to return highlighted emoji. Boiler plate code
function ServerDay(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;
  const isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;
  return (
    <Badge
      key={props.day.toString()}
      overlap="circular"
      badgeContent={isSelected ? '😡' : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </Badge>
  );
}

export default function DateCalendarServerRequest(props) {
  // const initialValue = dayjs('2022-04-17');
  // const requestAbortController = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [highlightedDays, setHighlightedDays] = React.useState();
  // const [date, setDate] = useState("");

  useEffect(() => {
    if(props.date && props.feeling) {
      const temp_Feelings = props.feeling.map((el) =>
      parseInt(moment(el.start_date).format("D"))
    );
    setHighlightedDays(temp_Feelings);
    setIsLoading(false);
    }
  }, [props.date, props.feeling])

  // -BF when the month changes, the selected date does not change unless user clicks on the date, hence we have to clear the feelings, on every month change and reget them if the user in the same month
  // as the selected month. 
  const handleMonthChange = (date) => {
    props.get_all_feelings(date.$d, props.session.user.id)
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        // value={props.date}
        value={dayjs(props.date)}
        onChange={(newValue) => {
          props.get_feelings_for_one_day(newValue.$d, props.session.user.id);
          props.setDate(newValue.$d)
        }}
        // defaultValue={dayjs(props.date)}
        loading={isLoading}
        onMonthChange={(e) => {
          handleMonthChange(e);
          props.setDate(e.$d);
          props.get_feelings_for_one_day(e.$d, props.session.user.id);
          console.log(e)
          // props.find_fight(e.$d);
        }}
        // renderLoading={() => <DayCalendarSkeleton />}
        slots={{
          day: ServerDay,
        }}
        slotProps={{
          day: {
            highlightedDays,
          },
        }}
        maxDate={dayjs()}
      />
    </LocalizationProvider>
  );
}
